import { Search, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export function AnimalSearchBar({ value, onChange }: Props) {
  const [local, setLocal] = useState(value);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    setLocal(value);
  }, [value]);

  function handleChange(next: string) {
    setLocal(next);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => onChange(next), 300);
  }

  function handleClear() {
    setLocal("");
    onChange("");
  }

  return (
    <div className="relative flex items-center">
      <Search
        size={15}
        className="pointer-events-none absolute left-3 text-app-ink-3"
        aria-hidden
      />
      <input
        type="search"
        value={local}
        onChange={(e) => handleChange(e.target.value)}
        placeholder="Buscar por tag, nombre o estado…"
        aria-label="Buscar animales"
        className="h-11 w-full rounded-xl border border-app-border bg-app-surface pr-9 pl-9 text-app-ink-1 text-base placeholder:text-app-ink-3 focus:outline-none focus:ring-2 focus:ring-app-emerald"
      />
      {local && (
        <button
          type="button"
          aria-label="Limpiar búsqueda"
          onClick={handleClear}
          className="absolute right-3 text-app-ink-3 hover:text-app-ink-1"
        >
          <X size={14} />
        </button>
      )}
    </div>
  );
}
